// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6348dbf0","453":"a373696c","796":"a971b82d"}[chunkId] + ".chunk.js";
};